'use client';
import { useEffect, useState } from 'react';
import BackArrow from '@/components/customercenter-ui/svgs/backArrow';
import { getCurrentDateTime } from '@/helpers/utils/siteUtils';
import Loader from '../loader';
interface BackButtonProps {
  text: string;
  className?: string;
  url: string;
  showBackArrow?: boolean;
}
const BackButton = ({ text, className, url, showBackArrow = true }: BackButtonProps) => {
  const [loading, setLoading] = useState(false);
  const [finalUrl, setFinalUrl] = useState<string>();

  useEffect(() => {
    if (url) {
      const timestamp = getCurrentDateTime().toString();
      const urlWithoutTimeStamp = removeTimestampFromRelativeUrl(url);
      const hasParams = urlWithoutTimeStamp.includes('?');
      const finalUrl = `${urlWithoutTimeStamp}${hasParams ? '&' : '?'}timeStamp=${timestamp}`;
      setFinalUrl(finalUrl);
    }
  }, [url]);

  const removeTimestampFromRelativeUrl = (relativeUrl: string): string => {
    const dummyBase = 'http://example.com';
    const urlObj = new URL(relativeUrl, dummyBase);
    urlObj.searchParams.delete('timestamp');
    urlObj.searchParams.delete('timeStamp');
    const path = urlObj.pathname;
    const search = urlObj.search;
    return `${path}${search}`;
  };

  return (
    <>
      {loading && <Loader />}
      <button onClick={() => setLoading(true)}>
        {finalUrl && (
          <a className={className} href={finalUrl}>
            {showBackArrow && (
              <span className="mr-2">
                <BackArrow />
              </span>
            )}
            {text}
          </a>
        )}
      </button>
    </>
  );
};

export default BackButton;
